import { useEffect, useState } from "react";
import { useDispatch } from "react-redux/es/exports";
import { Route, Routes, useNavigate } from "react-router-dom";

import Header from "../../components/Header";
import Navigation from "../../components/Navigation";
import { setActions, setColleagues, setDocgroups, setDoctypes, setDossiers, setDossiertypes, setFavoriteDocuments, setMetatypes, setUsers } from "../../redux/actions";
import styles from "../../styles/base/Portal.module.scss";
import Dashboard from "../Dashboard";
import Management from "../Management";

import jwt_decode from "jwt-decode";
import * as crypto from 'crypto-js';
import { getAllUsers } from "../../functions/fetch/user";
import Notification from "../../components/Notification";
import { useAppSelector } from "../../hooks/redux";
import Search from "../Search";
import Dossiers from "../Dossiers";
import Dossier from "../[dossier]";
import Subscriptions from "../Subscriptions";
import Loading from "./Loading";

import { useQuery } from "react-query";
import axiosPrimitive from 'axios'
import axios from "../../axios/axios"
import useAuth from "src/hooks/useAuth";
import toast, { Toaster } from "react-hot-toast";
import Communication from "../Communication";
import Cloud from "../cloud/Cloud";
import Workflows from "../workflows/Workflows";
import DocumentScanner from "../scanner/page";
import Articles from "../articles/page";


export default function Portal(){
    const {auth} = useAuth()
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const notification:NotificationObject = useAppSelector(state => state.notification);

    const [isLoading, setisLoading] = useState(true);
    const [isLoaded, setisLoaded] = useState(false);

    useEffect(()=>{fetchStartupData()}, [])

    useQuery<ForwardUser[] | null>({
        queryKey: [`colleagues`],
        queryFn: async () => {
            try {
                const token = auth.data?.token
                const { data } = await axios.get(`users/get`)
                if(data.errorcode!==0){ throw new Error(data.message) }
                if(!Array.isArray(data.object.users)){ throw new Error('users is no array') }
                
                let users = data.object.users.filter((i:ForwardUser)=>!i.blocked)
                dispatch(setColleagues(users))
                return users
            } catch (error) {
                return null
            }
        },
        refetchOnWindowFocus: false
    })

    useQuery({
        queryKey: ['favoriteDocuments'],
        queryFn: async () => {
            const token = auth.data?.token
            const {data} = await axios.get(`favorites/list`)
            if(data.errorcode!==0){throw new Error(data.message)}
            dispatch(setFavoriteDocuments(data.object || []))
            return data.object
        },
        refetchOnWindowFocus: false
    })

    useQuery({
        queryKey: ['dossiers'],
        queryFn: async () => {
            const token = auth.data?.token
            const {data} = await axios.get(`dossiers/get`)
            if(data.errorcode!==0){throw new Error(data.message)}
            dispatch(setDossiers(data.object))
            return data.object
        },
        refetchOnWindowFocus: false
    })

    type Key = 'docgroups' | 'doctypes' | 'dossiers' | 'dossiertypes' | 'metatypes' | 'actions'
    interface ResultObject {
        key: Key
        res?: any
    }

    const getStartupData = async () => {
        try {
            const token = auth.data?.token
            const response = await axiosPrimitive.all([
                axios.get(`docgroups/list`), //docgroups
                axios.get(`doctypes/list`), //doctypes
                axios.get(`dossiertypes/get`), //dossiertypes
                axios.get(`metatypes/list`), //metatypes
            ])

            const resultArr:ResultObject[] = [
                {key:'docgroups'},
                {key:'doctypes'},
                {key:'dossiertypes'},
                {key:'metatypes'},
            ]

            for (let i = 0; i < response.length; i++) {
                const {data} = response[i]
                // De API geeft fouten terug met HTTP 200 en errorcode != 0. Zonder deze
                // controle belandt een null-object stil in de store en verdwijnen er
                // overal documenten zonder dat er iets zichtbaar misgaat.
                if(data.errorcode !== 0){
                    throw new Error(`${resultArr[i].key}: ${data.message || `errorcode ${data.errorcode}`}`)
                }
                resultArr[i].res = data.object
            }

            let resultObj:{[K in Key]?:any} = {}
            resultArr.map(i=>{resultObj[i.key]=i.res})

            return resultObj
            
        } catch (error) {
            console.error("Opstartgegevens ophalen mislukt:", error)
            return null
        }
    }

    const fetchStartupData = async () => {
        console.log("Opstartgegevens ophalen...")
        const data = await getStartupData();
        if(data) {
            console.log("Opstartgegevens klaargezet")
            setisLoaded(true)

            dispatch(setDocgroups(data.docgroups))
            dispatch(setDoctypes(data.doctypes))
            dispatch(setDossiertypes(data.dossiertypes))
            dispatch(setMetatypes(data.metatypes))
            //dispatch(setActions(data.actions))
        }
        else { 
            console.log("Er liep iets mis bij het ophalen van de opstartgegevens") 
            toast.error(`Er liep iets mis bij het ophalen van de opstartgegevens. U wordt doorverwezen...`, {id:'startupData', duration:5000})
            setTimeout(()=>{navigate('/login')}, 5000)
        }
    }

    return (
        <>
        <Toaster />
        {isLoading &&
        <>
        <Loading endLoading={isLoaded} onComplete={()=>{setisLoading(false)}}/>
        </>
        }
        {!isLoading && 
        <div className={styles.portal}>  
            {/* <div className="fixed z-50 flex justify-center w-screen font-semibold text-white bg-red-600/60 backdrop-blur-sm">Dit is nog steeds in bèta modus. Veel zaken werken hierdoor nog niet.</div> */}

                <Notification object={notification}/>

                <Navigation />
                <div className={styles.content}>
                    <div className="w-full h-14 md:h-0 bg-neutral-100"></div>
                    {/* <Header /> */}
                    <Routes>
                        <Route path="*" element={<Dashboard />}/>
                        <Route path="zoeken" element={<Search />}/>
                        <Route path="dossiers" element={<Dossiers />}/>
                        <Route path="dossiers/:dossier" element={<Dossier />}/>
                        <Route path="communicatie" element={<Communication />}/>
                        <Route path="workflows/*" element={<Workflows />}/>
                        <Route path="cloud/*" element={<Cloud />}/>
                        <Route path="scanner/*" element={<DocumentScanner />}/>
                        <Route path="artikels/*" element={<Articles />}/>

                        <Route path="abonnement" element={<Subscriptions />}/>
                        <Route path="beheer" element={<Management />}/>
                    </Routes>
                </div>     
        </div>
        }
        </>
    )
}